import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ca from './locals/ca_ES.json'
import es from './locals/es_ES.json'
import en from './locals/en_GB.json'
import fr from './locals/fr_FR.json'
import eu from './locals/eu_ES.json'
import gl from './locals/gl_ES.json'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'es',
  messages: {
    en: { lang: en },
    es: { lang: es },
    ca: { lang: ca },
    fr: { lang: fr },
    eu: { lang: eu },
    gl: { lang: gl }
  },
})

